import { useMemo } from 'react';

const averageWPM = 250; // Average words per minute

const useReadingTimeCalculator = ({ content }: { content: string }) => {
  const readingTime = useMemo(() => {
    if (!content) return null;

    // Remove HTML tags and extra spaces
    const cleanContent = content.replace(/<[^>]*>?/gm, '').trim();

    // Split by spaces to count words
    const words = cleanContent.split(/\s+/).filter(word => word.length > 0);
    const wordCount = words.length;

    // Calculate reading time in minutes, rounded up
    const minutes = Math.ceil(wordCount / averageWPM);

    if (minutes <= 1) {
      return '1 minute';
    }

    return `${minutes} minutes`;
  }, [content]);

  return {
    readingTime
  };
};

export default useReadingTimeCalculator;
